import { convertArrayToCSV } from "convert-array-to-csv"
import handleize from "./handleize.js"

export const serializeIntoCSV = ({
	products,
	productsUrl,
	selectedProductsIds,
	tags,
	vendor,
	publishChecked,
	collectionsSelected,
	status = "active",
}) => {
	let csvFilename = `kopyexport_${encodeURIComponent(productsUrl)}_${new Date().toISOString()}.csv`
	let productsToSubmit = products.filter((product) =>
		selectedProductsIds.includes(product.id),
	)

	const csvArray = productsToSubmit
		.map((product) => {
			const variantIdToVariantImageSrcMapping = {}
			const imageIdsThatAlreadyBelongToAVariant = []

			product?.variants?.map((variant) => {
				if (variant.featured_image?.id && variant.featured_image?.src) {
					variantIdToVariantImageSrcMapping[variant.id] =
						variant.featured_image.src
					imageIdsThatAlreadyBelongToAVariant.push(
						variant.featured_image.id,
					)
				} else if (variant?.image_id) {
					const variantImageSrc =
						product.images.find(
							(img) => img.id === variant.image_id,
						)?.src || ""
					if (!variantImageSrc) return

					variantIdToVariantImageSrcMapping[variant.id] =
						variantImageSrc
					imageIdsThatAlreadyBelongToAVariant.push(variant.image_id)
				}
			})

			const remainingImagesSrc = []

			product?.images?.map((image) => {
				if (
					image?.src &&
					image?.id &&
					!imageIdsThatAlreadyBelongToAVariant.includes(image?.id) &&
					image?.src !== product.images?.[0]?.src
				) {
					remainingImagesSrc.push(image.src)
				}
			})

			let imgPos = 1
			const variants = product.variants || []

			return [
				{
					...product,
					_type: "product",
					_variantImg:
						variantIdToVariantImageSrcMapping[
							product.variants?.[0]?.id
						],
				},
				...remainingImagesSrc.map((img, i) => {
					imgPos = imgPos + 1
					return {
						_type: "image",
						_title: product.title,
						_image: img,
						_imgPos: imgPos,
					}
				}),
				...variants.slice(1).map((v, i) => {
					if (variantIdToVariantImageSrcMapping[v.id])
						imgPos = imgPos + 1

					return {
						...v,
						_type: "variant",
						_title: product.title,
						_imgSrc: variantIdToVariantImageSrcMapping[v.id] || "",
						_imgPos: variantIdToVariantImageSrcMapping[v.id]
							? imgPos
							: "",
						_imgAlt: product.images[i + 1]?.alt || "",
						_variantImgSrc: v.featured_image?.src,
					}
				}),
			]
		})
		.flat()
		.map((product) => {
			let productTags = []
			if (product._type === "product") {
				if (!product.tags) {
					productTags = [...tags]
				} else if (Array.isArray(product.tags)) {
					productTags = [...product.tags, ...tags]
				} else if (product.tags.length > 0 && product.tags.split) {
					productTags = [...product.tags.split(", "), ...tags]
				}
			}

			let productToSubmit = {}

			productToSubmit["Handle"] = handleize(
				product._type === "product" ? product.title : product._title,
			)

			productToSubmit["Title"] =
				product._type === "product" ? product.title : ""
			productToSubmit["Body (HTML)"] =
				product._type === "product" ? product.body_html : ""
			productToSubmit["Vendor"] =
				product._type === "product" ? vendor : ""
			productToSubmit["Tags"] =
				product._type === "product" ? productTags.join(",") : ""

			productToSubmit["Published"] =
				product._type === "image" ? "" : publishChecked
			productToSubmit["Option1 Name"] =
				product._type === "product"
					? product.options?.[0]?.name || ""
					: ""
			productToSubmit["Option2 Name"] =
				product._type === "product"
					? product.options?.[1]?.name || ""
					: ""
			productToSubmit["Option3 Name"] =
				product._type === "product"
					? product.options?.[2]?.name || ""
					: ""
			productToSubmit["Option1 Value"] =
				product._type === "product"
					? product.variants?.[0]?.option1 || ""
					: product.option1 || ""
			productToSubmit["Option2 Value"] =
				product._type === "product"
					? product.variants?.[0]?.option2 || ""
					: product.option2 || ""
			productToSubmit["Option3 Value"] =
				product._type === "product"
					? product.variants?.[0]?.option3 || ""
					: product.option3 || ""

			productToSubmit["Variant SKU"] =
				product._type === "product"
					? product.variants?.[0]?.sku || ""
					: product.sku || ""
			productToSubmit["Variant Grams"] =
				product._type === "image"
					? ""
					: product._type === "product"
						? product.variants?.[0]?.grams || ""
						: product.grams || 0

			productToSubmit["Variant Inventory Tracker"] = ""
			productToSubmit["Variant Inventory Qty"] = ""
			productToSubmit["Variant Inventory Policy"] =
				product._type === "image" ? "" : "deny"
			productToSubmit["Variant Fulfillment Service"] =
				product._type === "image" ? "" : "manual"

			productToSubmit["Variant Price"] =
				product._type === "product"
					? product.variants?.[0]?.price || ""
					: product.price || ""
			productToSubmit["Variant Compare At Price"] =
				product._type === "product"
					? product.variants?.[0]?.compare_at_price || ""
					: product.compare_at_price || ""
			productToSubmit["Variant Requires Shipping"] =
				product._type === "image" ? "" : "TRUE"
			productToSubmit["Variant Taxable"] =
				product._type === "image" ? "" : "TRUE"
			productToSubmit["Variant Barcode"] = ""

			productToSubmit["Image Src"] =
				product._type === "image"
					? product._image || ""
					: product._type === "variant"
						? product._imgSrc || ""
						: product._type === "product"
							? product.variants?.[0]?.featured_image?.src ||
								product.images?.[0]?.src ||
								""
							: ""

			productToSubmit["Image Position"] = productToSubmit["Image Src"]
				? product._type === "product"
					? product.images?.[0]?.src
						? 1
						: ""
					: product._imgPos || 1
				: ""

			productToSubmit["Image Alt Text"] = productToSubmit["Image Src"]
				? product._type === "product"
					? product.images?.[0]?.src
						? product.images?.[0]?.alt || ""
						: ""
					: product._imgAlt || ""
				: ""

			productToSubmit["Gift Card"] =
				product._type === "image" ? "" : "FALSE"
			productToSubmit["SEO Title"] = ""
			productToSubmit["SEO Description"] = ""

			productToSubmit["Google Shopping / Google Product Category"] = ""
			productToSubmit["Google Shopping / Gender"] = ""
			productToSubmit["Google Shopping / Age Group"] = ""
			productToSubmit["Google Shopping / MPN"] = ""
			productToSubmit["Google Shopping / AdWords Grouping"] = ""
			productToSubmit["Google Shopping / AdWords Labels"] = ""
			productToSubmit["Google Shopping / Condition"] = ""
			productToSubmit["Google Shopping / Custom Product"] = ""
			productToSubmit["Google Shopping / Custom Label 0"] = ""
			productToSubmit["Google Shopping / Custom Label 1"] = ""
			productToSubmit["Google Shopping / Custom Label 2"] = ""
			productToSubmit["Google Shopping / Custom Label 3"] = ""
			productToSubmit["Google Shopping / Custom Label 4"] = ""

			productToSubmit["Variant Image"] =
				product._type === "product"
					? product.variants?.[0]?.featured_image?.src ||
						product._variantImg ||
						""
					: product._type === "variant"
						? product._imgSrc || ""
						: ""
			productToSubmit["Variant Weight Unit"] = ""
			productToSubmit["Variant Tax Code"] = ""
			productToSubmit["Cost per item"] = ""
			productToSubmit["Status"] = product._type === "image" ? "" : status
			productToSubmit["Standard Product Type"] = ""
			productToSubmit["Custom Product Type"] = ""
			productToSubmit["Collection"] =
				collectionsSelected.length > 0
					? collectionsSelected[0].title
					: ""

			return productToSubmit
		})

	let csvString = convertArrayToCSV(csvArray)

	let csvUrl = ""
	var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" })
	if (navigator.msSaveBlob) {
		// IE 10+
		navigator.msSaveBlob(blob, csvFilename)
	} else {
		csvUrl = URL.createObjectURL(blob)
	}

	return { csvUrl, csvFilename }
}
